import { Component, OnInit } from "@angular/core";
import { SelectItem } from "primeng/api";
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService, StripeInsightsMetricSeries } from "src/app/Services/dashboard.service";
import { ArtistDashboard } from "src/app/models/response/artistdashboard.models";
import { AdminDashboardApiResponce } from "src/app/models/response/artistoverlaydashboard.model";

@Component({
    selector: 'admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    standalone: false
})

export class AdminDashboard implements OnInit{
    public selectedStripeDuration: number = 365;
    public stripeDurationOptions: SelectItem[] = [
        { label: 'Last 1 week', value: 7 },
        { label: 'Last 1 month', value: 30 },
        { label: 'Last 3 months', value: 90 },
        { label: 'Last 6 months', value: 180 },
        { label: 'Last 1 year', value: 365 }
    ];
    // public dashboardData: AdminDashboardApiResponce = {
    //     IncomingArtistConnectionRequest: []
    // };
    public AdminDashboardData!: AdminDashboardApiResponce;
    public adminDashboardDataLoaded: boolean = false;
    public selectedTabIndex: number = 0;

    constructor(private dashboardService:DashboardService,private ngxSpinnerService:NgxSpinnerService){

    }
    ngOnInit(): void {
        this.getPaidInvoicesHistory()
    }

    public getPaidInvoicesHistory(){
        this.ngxSpinnerService.show();
        this.dashboardService.getAllSubscriptions().subscribe((res: AdminDashboardApiResponce)=>{
            // console.log(res)
            this.AdminDashboardData = res
            console.log(this.AdminDashboardData)
            this.ngxSpinnerService.hide()
            this.adminDashboardDataLoaded = true;
        }, (error) => { console.error('Error while fetching admin dashboard data', error); this.ngxSpinnerService.hide(); });
    }
    
    public onTabChange(event: any) {
        if (event.index) {
            this.selectedTabIndex = event.index ;      
          } else {
            console.log('Event is undefined or index is not present');
          }
   }

}